module.exports = __webpack_public_path__ + "media/images/instagram_black-6144a3514526ad0efeac2bfd69f9a945.png";